export enum ShareType {
  Url = 0,
  Email = 1,
}
